// extracted by mini-css-extract-plugin
export var button = "payu-card-form-module--button--2f9a9";
export var card = "payu-card-form-module--card--13886";
export var cardCvv = "payu-card-form-module--card-cvv--5a059";
export var cardExpiration = "payu-card-form-module--card-expiration--701dc";
export var cardNumber = "payu-card-form-module--card-number--7edbe";
export var container = "payu-card-form-module--container--e8d34";
export var error = "payu-card-form-module--error--d3d01";
export var errorsBox = "payu-card-form-module--errors-box--d5497";
export var header = "payu-card-form-module--header--6b446";
export var input = "payu-card-form-module--input--232e6";
export var label = "payu-card-form-module--label--cdbfc";
export var title = "payu-card-form-module--title--6627c";